import * as React from "react";
import i18n from "i18next";

import {OptionBasicDtoOptionType} from "../../../services/Client";

import SelectField from "../../../components/SelectField";
import {sortOptionTypes} from "../../../components/Table/dataHandler/Utils";

interface IMultiOptionTypeSelectionProps {
    /** Displayed when there's no option type selected. */
    placeholder?: string;

    /** Initially selected option type. */
    value?: OptionBasicDtoOptionType[];

    /** Callback when an option type is selected or the select field is cleared. */
    onChange: (value: OptionBasicDtoOptionType[] | undefined) => any;
}

/**
 * MultiOptionTypeSelection is a multi select field component that enables the selection of
 * option types
 */
const MultiOptionTypeSelection = (props: IMultiOptionTypeSelectionProps) => (
    <SelectField
        placeholder={props.placeholder}
        searchable={false}
        multi={true}
        value={props.value}
        dataSource={Object.keys(OptionBasicDtoOptionType).sort(sortOptionTypes)}
        rendererKey={(value: OptionBasicDtoOptionType) => i18n.t("GLOBAL:" + value) + " (" + value + ')'}
        onChange={(values: any[]) => {
            props.onChange(values.length !== 0 ? values.map((v) => v.selectedValue) as OptionBasicDtoOptionType[] : undefined);
        }}
    />
);

export default MultiOptionTypeSelection;



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/MultiOptionTypeSelection.tsx